import axios from 'axios';
import { default as commonApi } from 'config/commonApiConf';

const auth_token = localStorage.getItem('auth_token');
const api = axios.create({
	baseURL: process.env.REACT_APP_API_URL + '/admin',
	timeout: 15000,
	headers: { Authorization: 'Bearer ' + auth_token },
});

export const getAuthUser = async (data = {}) => {
	try {
		let result = await api.get('/get-auth-user', data);
		return result;
	} catch (error) {
		return error;
	}
};

export const getCartService = async () => {
	try {
		let result = await commonApi.get('/front/customer/get-cart');
		return result;
	} catch (error) {
		return error;
	}
};
